import { Box, TextNew } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { styles } from './index'

export const Entity = ({ type, label, setHover, handlePress, hover }: any) => {
  const value = type === 'link' || 'downloadEntityConfig' ? label.toString() : `#${label.toString()}`
  return (
    <>
      {!isEmpty(label?.toString() ?? '') && (
        <Box
          onHover={setHover}
          onPress={handlePress}
          underlayColor={'TRANSPARENT'}
          flexDirection="row"
          alignItems="center">
          <TextNew {...styles.labelStyle} color={'PRIMARY'} textDecorationLine={hover ? 'underline' : 'none'}>
            {value}
          </TextNew>
        </Box>
      )}
    </>
  )
}
